import React, { useEffect, useState } from "react";
import axiosInstance from "../../../../utils/axiosInstance";
import { Link } from "react-router-dom";
import DeleteProducts from "../../products/DeleteProducts";

export default function Specialcomp() {
  const [specialProducts, setSpecialProducts] = useState([]);

  useEffect(() => {
    const fetchSpecialProducts = async () => {
      try {
        const response = await axiosInstance.get("/api/products/special");
        setSpecialProducts(response.data);
      } catch (error) {
        console.error("Error fetching special products:", error);
      }
    };

    fetchSpecialProducts();
  }, []);
  const handleDeleteSuccess = async () => {
    try {
      const updatedProducts = await specialProducts();
      specialProducts(updatedProducts);
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };
  return (
    <div className="container mx-auto mt-20">
      <h2 className="text-2xl font-bold mb-4">Special Products</h2>
      <div className="container mx-auto mt-8">
        <div className="grid grid-cols-2 md:mx-36 mx-5 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {specialProducts.map((product, index) => (
            <>
              <div
                key={index}
                className="p-4 border rounded-md shadow-md bg-white"
              >
                <Link to={`/admin/update/${product._id}`} className="block">
                  {/* <img src={product.image} alt={product.name} className="mb-4 w-full h-32 object-cover rounded-md" /> */}
                  <img
                    src={`${axiosInstance.defaults.baseURL}/${product.image}`}
                    alt={product.name}
                    className="mb-4 w-full h-32 object-cover rounded-md"
                  />

                  <h3 className="text-sm md:text-lg font-semibold text-gray-800">
                    {product.name}
                  </h3>
                  <div className="flex items-center">
                    <p className="text-red-600 text-sm md:text-lg mr-2 line-through">
                      {product.originalprice}
                    </p>
                    <p className="text-gray-500 text-sm md:text-lg font-semibold">
                      {product.discountprice}
                    </p>
                  </div>
                  {/* Calculate and display the discount percentage */}
                  <p className="text-green-600 text-sm md:text-lg font-semibold">
                    Save{" "}
                    {(
                      ((product.originalprice - product.discountprice) /
                        product.originalprice) *
                      100
                    ).toFixed(2)}
                    %
                  </p>
                </Link>
                <div className="flex justify-between mt-4">
                  <Link
                    to={`/admin/update/${product._id}`}
                    className="text-blue-500 hover:underline"
                  >
                    Update
                  </Link>

                  {/* Add the DeleteProducts component with the product ID */}
                  <DeleteProducts
                    id={product._id}
                    onDeleteSuccess={handleDeleteSuccess}
                  />
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
    </div>
  );
}
